import { gql } from "gql";

export const DELETE_DYNAMIC_ATTRIBUTE_GROUP = gql(/* GraphQL */ `
  mutation DeleteDynamicAttributeGroup($id: ID!) {
    removeDynamicAttributeGroup(id: $id)
  }
`);
